import { useId } from "react";
import { useTranslation } from "react-i18next";

import { Tooltip } from "@/components/Tooltip/Tooltip";

export function MetricHelp({ label, definition }: { label: string; definition: string }) {
	const id = useId();

	return (
		<Tooltip content={<span role="tooltip">{definition}</span>}>
			<button
				aria-describedby={id}
				aria-label={label}
				className="cursor-pointer rounded-full px-1 text-text-meta focus-visible:outline-brand-light"
				type="button"
			>
				ⓘ
			</button>
			<span className="sr-only" id={id}>
				{definition}
			</span>
		</Tooltip>
	);
}
export function MetricTitle({
	metric,
	definition,
	values,
}: {
	metric: string;
	definition?: string;
	values?: Record<string, string | number>;
}) {
	const { t } = useTranslation();

	return (
		<span className="inline-flex items-center gap-1">
			{t(`featureUsage.metrics.${metric}`)}
			<MetricHelp
				definition={t(`featureUsage.help.${definition ?? metric}`, values ?? {})}
				label={t(`featureUsage.metrics.${metric}`)}
			/>
		</span>
	);
}
